<template>
  <div class="text-center">
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title class="text-h6 primary white--text">
          Selecione as turmas infantis</v-card-title
        >
        <e-autocomplete
          :id="`modal_bncc.select_turmas_bncc_escola_${franquia_id}`"
          class="px-3 my-5"
          :items="turmasList"
          item-text="descricao"
          item-value="id"
          multiple
          return-object
          label="Selecione uma ou mais turmas"
          v-model="turmasSelecionadas"
        >
          <template v-slot:item="data">
            <v-list-item
              v-bind="data.attrs"
              v-on="data.on"
              :id="`modal_boletins.turma_${data.item.id}_escola_${franquia_id}`"
            >
              <v-list-item-content>
                <v-list-item-title>{{ data.item.descricao }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </e-autocomplete>

        <div v-if="turmasSelecionadas.length > 0" class="px-3 mb-3">
          <v-chip small color="primary" class="mb-2">
            {{ turmasSelecionadas.length }} turma{{
              turmasSelecionadas.length > 1 ? "s" : ""
            }}
            selecionada{{ turmasSelecionadas.length > 1 ? "s" : "" }}
          </v-chip>

          <v-alert v-if="turmasSelecionadas.length > 5" type="warning" dense outlined class="mb-2">
            <v-icon small class="mr-2">mdi-clock-alert</v-icon>
            Atenção: A geração do documento com mais de 5 turmas pode demorar mais tempo.
          </v-alert>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="modal_boletins.btn_fechar"
            color="primary"
            text
            @click="$emit('dialogChange', false)"
          >
            Fechar
          </v-btn>
          <v-btn
            id="modal_boletins.btn_confirmar"
            color="primary"
            text
            @click="confirmarSelecao"
            :disabled="turmasSelecionadas.length === 0"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmacao" persistent width="640">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left>mdi-alert-circle</v-icon>
          Confirmação necessária
        </v-card-title>

        <v-card-text class="pt-4">
          <div class="text-center">
            <v-icon size="40" color="primary">mdi-clock-alert</v-icon>
            <p class="mt-3 mb-1 font-weight-medium">
              Você selecionou <strong>{{ turmasSelecionadas.length }}</strong> turma{{
                turmasSelecionadas.length > 1 ? "s" : ""
              }}
            </p>
            <p class="text-caption grey--text">
              Processar acima de 5 turmas pode impactar a performance
            </p>
          </div>

          <v-divider class="my-4"></v-divider>

          <div class="mb-3">
            <p class="mb-2">Turmas selecionadas:</p>
            <div class="d-flex flex-wrap">
              <v-chip
                v-for="turma in turmasSelecionadas"
                :key="turma.id"
                class="ma-1"
                color="primary"
                outlined
                small
              >
                {{ turma.descricao }}
              </v-chip>
            </div>
          </div>

          <v-alert v-if="turmasSelecionadas.length > 5" type="info" outlined class="mt-4">
            <div>
              <strong>Tempo estimado:</strong> Esta operação pode levar alguns minutos para ser
              concluída.
            </div>
            <div class="mt-1">
              <strong>Recomendação:</strong> Considere processar as turmas em lotes menores (1-5)
              para melhor performance.
            </div>
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-btn color="grey" text @click="dialogConfirmacao = false">
            <v-icon left>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="white--text" @click="gerarRelatorio">
            <v-icon left>mdi-check</v-icon>
            Continuar mesmo assim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    franquia_id: {
      type: Number,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      turmasList: [],
      turmasSelecionadas: [],
      dialogConfirmacao: false,
    };
  },
  watch: {
    dialog: {
      async handler(newVal) {
        if (newVal) {
          await this.listarTurmasFranquiaSelect(this.franquia_id);
        }
      },
    },
  },
  methods: {
    async listarTurmasFranquiaSelect(franquia) {
      this.carregandoTurmas = true;
      try {
        const response = await this.$services.turmasService.listarTurmasInfantisFranquia({
          franquia_id: franquia,
        });

        this.turmasList = response;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregandoTurmas = false;
      }
    },
    async confirmarSelecao() {
      if (this.turmasSelecionadas.length === 0) {
        this.$toast.danger("Selecione pelo menos uma turma.");
        return;
      }

      if (this.turmasSelecionadas.length > 5) {
        this.dialogConfirmacao = true;
      } else {
        this.gerarRelatorio();
      }
    },
    async gerarRelatorio() {
      this.dialogConfirmacao = false;
      this.$loaderService.open("Carregando dados...");
      try {
        await this.$services.relatoriosService.relatoriosBnccFranquia(
          this.franquia_id,
          this.turmasSelecionadas.map((turma) => turma.id)
        );
        this.turmasSelecionadas = [];
        this.$emit("dialogChange", false);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* Estilo personalizado, se necessário */
</style>
